import { Global } from '@emotion/react';

import { publicAssetPath } from 'utils/publicUrl';

const Fonts = () => {
  const comfortaaRegularWoff2 = publicAssetPath('/fonts/comfortaa-v40-latin-regular.woff2');
  const comfortaaRegularWoff = publicAssetPath('/fonts/comfortaa-v40-latin-regular.woff');
  const comfortaaBoldWoff2 = publicAssetPath('/fonts/comfortaa-v40-latin-700.woff2');
  const comfortaaBoldWoff = publicAssetPath('/fonts/comfortaa-v40-latin-700.woff');
  const robotoRegularWoff2 = publicAssetPath('/fonts/roboto-v30-latin-regular.woff2');
  const robotoRegularWoff = publicAssetPath('/fonts/roboto-v30-latin-regular.woff');
  const robotoBoldWoff2 = publicAssetPath('/fonts/roboto-v30-latin-700.woff2');
  const robotoBoldWoff = publicAssetPath('/fonts/roboto-v30-latin-700.woff');

  return (
    <Global
      styles={`
        @font-face {
            font-weight: 400;
            font-family: Comfortaa Regular;
            font-style: normal;
            src: url('${comfortaaRegularWoff2}') format('woff2'),
            url('${comfortaaRegularWoff}') format('woff');
            font-display: swap;
        }
        @font-face {
            font-weight: 400;
            font-family: Comfortaa;
            font-style: normal;
            src: url('${comfortaaRegularWoff2}') format('woff2'),
            url('${comfortaaRegularWoff}') format('woff');
            font-display: swap;
        }
        @font-face {
          font-weight: 700;
          font-family: Comfortaa Bold;
          font-style: normal;
          src: url('${comfortaaBoldWoff2}') format('woff2'),
          url('${comfortaaBoldWoff}') format('woff');
          font-display: swap;
        }
        @font-face {
          font-weight: 700;
          font-family: Comfortaa;
          font-style: normal;
          src: url('${comfortaaBoldWoff2}') format('woff2'),
          url('${comfortaaBoldWoff}') format('woff');
          font-display: swap;
        }
        @font-face {
          font-weight: 400;
          font-family: Roboto Regular;
          font-style: normal;
          src: url('${robotoRegularWoff2}') format('woff2'),
          url('${robotoRegularWoff}') format('woff');
          font-display: swap;
        }
        @font-face {
        font-weight: 700;
        font-family: Roboto Bold;
        font-style: normal;
        src: url('${robotoBoldWoff2}') format('woff2'),
        url('${robotoBoldWoff}') format('woff');
        font-display: swap;
        }
      `}
    />
  );
};

export default Fonts;
